import React from "react";
import type { DisplayFieldProps } from "../../../interfaces/components/form";
import CurrencyDisplay from "../../CurrencyDisplay";

export const DisplayField: React.FC<DisplayFieldProps> = ({
  name,
  value,
  label,
  type,
}) => {
  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  const displayValue =
    type === "number" ? (
      <CurrencyDisplay amount={numericValue || 0} currency="USD" /> // Default currency, can be improved
    ) : (
      value || "N/A"
    );

  return (
    <div className="relative w-full">
      <div className="mt-1 pl-2 flex text-sm items-center w-full rounded-lg border border-gray-300 dark:border-gray-700 min-h-[34px]">
        {displayValue}
      </div>
    </div>
  );
}; 